<template>
	<div class="tw-text-center tw-flex tw-flex-col tw-gap-2">
		<div>
			<p-button :outlined="true" min-width="260px" @click="handleFileDownload()">
				Plantilla para puestos
			</p-button>
		</div>
		<div>
			<p-button min-width="260px" @click="handleOpenTutorial()">
				Mira nuestro tutorial paso a paso
			</p-button>
			<youtube-dialog
				:video-src="moduleConfiguration.videoUrl"
				ref="tutorialYoutubeRef"
			></youtube-dialog>
		</div>
	</div>
</template>
<script>
import PButton from '../../shared/components/ui/p-button';
import YoutubeDialog from '../../shared/components/business/youtube-dialog';
import { downloadUrl } from '../../shared/utils/download';

export default {
	components: { YoutubeDialog, PButton },
	name: 'ThreeSixtyHelp',
	props: {
		moduleConfiguration: {
			default: () => ({}),
		},
	},
	methods: {
		handleOpenTutorial() {
			this.$refs.tutorialYoutubeRef.open();
		},
		handleFileDownload() {
			downloadUrl(this.moduleConfiguration.fileUrl);
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/modules/three-sixty-evaluation/commons/three-sixty-help.vue